type ItemsArrStr = {
  [key: string]: string | null;
};

export class MemoryStorage implements Storage {
  items: ItemsArrStr = {};

  getItem(key: string) {
    return this.items[key];
  }

  setItem(key: string, value: string) {
    this.items[key] = value;
  }

  removeItem(key: string) {
    delete this.items[key];
  }

  key(index: number) {
    return Object.keys(this.items)[index];
  }

  get length() {
    return Object.keys(this.items).length;
  }

  clear() {
    this.items = {};
  }
}

// We need to fallback to memory storage implementation since native `localStorage` is not available if Tink Link is
// running in iframe, and user has enabled 'Block third-party cookies' option in browser settings.
// https://tinkab.atlassian.net/browse/SDK-432

let availableStorage: Storage;

try {
  window.localStorage.setItem('test', '1');
  window.localStorage.removeItem('test');
  availableStorage = window.localStorage;
} catch (e) {
  availableStorage = new MemoryStorage();
}

export const storage = availableStorage;
